// src/features/todo/todoSlice.js
import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Staff, STAFF_STATUS } from "features/staff/types";

export interface TokenInfo {
	user: number;
	id: number;
	userType: number;
	jwt: string;
	expireIn: number;
	refreshToken: string;
	refreshTokenexpireIn: number;
	revoke: boolean;
	createdAt?: string;
	updatedAt?: string;
}
interface Auth {
	auth: TokenInfo | null;
	myProfile: Staff;
}

const initialState: Auth = {
	auth: null,
	myProfile: {
		id: 0,
		username: "",
		fullName: "",
		avatar: "",
		phoneNumber: "",
		email: "",
		idCard: "",
		gender: 1,
		birthday: "",
		status: STAFF_STATUS.ENABLE,
		userType: 3,
		address: "",
		roles: [],
		permissions: [],
	},
};

export const authSlice = createSlice({
	name: "app",
	initialState,
	reducers: {
		setAuth: (state, action) => {
			state.auth = action.payload;
		},
		setMyProfile: (state, action) => {
			state.myProfile = action.payload;
		},
	},
});

export const { setAuth, setMyProfile } = authSlice.actions;

export const selectAuth = (state: RootState) => state.auth.auth;
export const selectMyProfile = (state: RootState) => state.auth.myProfile;

export interface LoginAsyncPayload {
	username: string;
	password: string;
}
export const loginAsync = createAction(
	"auth/loginAsync",
	(payload: LoginAsyncPayload) => ({
		payload,
	}),
);

export const logoutAsync = createAction("auth/logoutAsync");

export interface GetMyProfilePayload {
	returnAction?: () => void;
}

export const getMyProfileAsync = createAction(
	"staff/getMyProfileAsync",
	(payload: GetMyProfilePayload) => ({
		payload,
	}),
);

export default authSlice.reducer;
